import{gql as e}from"@apollo/client";const t=e`
  query getUserFlows($filterWithConditions: Boolean, $projectId: String!) {
    userFlow {
      getUserFlows(filterWithConditions: $filterWithConditions, projectId: $projectId) {
        id
        url
        userFlowSteps {
          contentGroup {
            contentPages(status: [PUBLISHED, UNPUBLISHED], topLevelOnly: true) {
              ...userFlowStepContentPageForUserFlows
            }
            description
            groupingContentGroup {
              description
              id
              name
              url
            }
            id
            title
          }
          description
          id
          isComplete
          lastViewedContentPage {
            ...userFlowStepContentPageForUserFlows
          }
          percentageCompleted
          sort
          stepName
          url
          userStatus
        }
      }
    }
  }

  fragment userFlowStepContentPageForUserFlows on ContentPageType {
    hasBeenViewed
    id
    sort
    title
    url
  }
`;export{t as GET_USER_FLOWS};
//# sourceMappingURL=useGetUserFlows.graphql.js.map
